import { render } from "./UserAccountRegisterView.vue?vue&type=template&id=7d5971d8&scoped=true"
import script from "./UserAccountRegisterView.vue?vue&type=script&lang=js"
export * from "./UserAccountRegisterView.vue?vue&type=script&lang=js"

import "./UserAccountRegisterView.vue?vue&type=style&index=0&id=7d5971d8&scoped=true&lang=css"

import exportComponent from "D:\\服务器\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d5971d8"]])

export default __exports__